<template>
    <v-container fluid>
      <v-card>
        <v-toolbar color="secondary" flat dense>
          <v-toolbar-title>UoM</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>

        <v-card-text>
          <v-row>

            <v-col cols="12">
              <v-btn color="primary" small to="/inventory/new-uom">
            <v-icon left dark>mdi-plus</v-icon> New Unit of Measure
          </v-btn>

            </v-col>
            <v-col cols="4" sm="4" md="4">
              <v-data-table :loading="loading" loading-text="Loading... Please wait" :headers="headers" :items="uom" :search="search"></v-data-table>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-container>
</template>

<script>
export default {
  data: () => ({
    search: "",
    loading: false,
    uom: [],
    headers: [
      { text: "UOM Name", value: "UomName" }
    ],
  }),
  methods: {
    getUom() {
      const self = this;
      this.loading = true;
       this.$store
        .dispatch("get", `/uoms`)
        .then(res => {
          self.uom = res.ResponseData;
          self.loading = false;
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    }
  },
  created() {
    this.getUom();
  }
};
</script>